// extracted by mini-css-extract-plugin
export default {"notFoundV2":"FpjDP","notFoundV2__image":"_29rYX","notFoundV2__errorTitle":"_2RBHj","notFoundV2__errorDescription":"_1c4Ng","notFoundV2__homeButton":"_2IJGI"};